import parse from 'react-html-parser';

import { CANCELLATION_INSTRUCTIONS_URL } from '@components/SubscriptionForm/StripeDisclosure';

export const renewCancelText = (description: string) => {
  if (description.includes('canceled online')) {
    const replaced = description.replace(
      /canceled online/g,
      `<a href="${CANCELLATION_INSTRUCTIONS_URL}" class="underline hover:text-primary-magenta dark:hover:text-primary-pink">canceled online</a>`
    );
    return parse(replaced);
  }
  return parse(description);
};
